<template>
  <div class="flex flex-col h-screen bg-gray-200 font-roboto dark:bg-gray-950">
    <ImpersonationBanner/>

    <div class="flex flex-1 overflow-hidden">
      <SidebarMenu :isOpen="isOpen" @closeMenu="closeMenu"/>

      <div class="flex-1 flex flex-col overflow-hidden">
        <HeaderMenu :isOpen="isOpen" @openMenu="openMenu" />

        <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200 dark:bg-gray-950">
          <div class="container mx-auto px-6 py-8">

            <router-view/>
          </div>
        </main>
      </div>
    </div>
  </div>

</template>

<script>
import HeaderMenu from "./../menu/HeaderMenu";
import SidebarMenu from "./../menu/SidebarMenu";
import ImpersonationBanner from "./ImpersonationBanner";

export default {
    components: {
        HeaderMenu,
        SidebarMenu,
        ImpersonationBanner,
    },
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        closeMenu() {
            this.isOpen = false;
        },
        openMenu(){
            this.isOpen = true;
        }
    },
    watch: {
        $route() {
            this.isOpen = false;
        }
    }
}
</script>